import React, {useEffect, useState} from 'react';
import L from 'leaflet';
import './App.css';
import {BaseMarkerIcon} from "./components/MarkersIcon/MarkerIcon";

// Milk Lemon font
import './fonts/lemon-milk.css';
import './fonts/LEMONMILK-Medium.otf';
import './fonts/LEMONMILK-Regular.otf';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/dist/styles.min.css';

import GeoLocationMarker from './components/Markers/GeolocationMarker'
import StoresMarker from './components/Markers/StoresMarker'
import { MapContainer, TileLayer} from 'react-leaflet';
import LocationButton from './components/LeafletButtons/LocationButton'
import useMenuSide from "./hooks/useMenuSide";
import useSettingsApi from "./hooks/useSettingsApi";
import Searchbar from "./components/searchbar/searchbar";
import SearchbarButton from "./components/LeafletButtons/searchbarButton";
import useStoresData from "./hooks/useStoresData";



/**
 * App init
 * @returns {JSX.Element}
 * @constructor
 */
const App = () => {



    //Default map center location
    const defaultMapValues = {
        lat: 47.731413228218386,
        lng: 2.6120384438007953,
        zoom:5
    };
    const menuSide = useMenuSide()

    const {data:stores,loading,error} = useStoresData();
    const {data:settings} = useSettingsApi();

    //Change marker default design
    L.Marker.prototype.options.icon = BaseMarkerIcon(settings);

    return (
        <div className={`store_locator-container ${menuSide ? 'side-marker-list' : ''}`}>
            <div id={'my-map'}>
                <div id={'loader-screen'}>

                </div>
                {menuSide !== null ?
                <MapContainer tap={false} center={[defaultMapValues.lat, defaultMapValues.lng]} zoom={defaultMapValues.zoom} scrollWheelZoom={true} >
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                    />

                    <GeoLocationMarker isLoading={loading}/>
                    <StoresMarker settings={settings} storesData={stores} isLoading={loading}/>
                    <LocationButton icon={'fas fa-map-marker-alt'} iconLoader={'fas fa-circle-notch fa-spin'}/>
                    <SearchbarButton icon={'fas fa-map-marker-alt'} iconLoader={'fas fa-circle-notch fa-spin'}/>
                </MapContainer> :
                ''
                }
            </div>
            <div id={'marker-list-button'}>

            </div>
            <div id={'marker-list'}>

            </div>

        </div>
    );
}

export default App;
